import { Component, OnInit, Input} from '@angular/core';
import { AlertService } from 'src/app/alertas/services/alert.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';
@Component({
  selector: 'app-user-alert-config',
  templateUrl: './user-alert-config.component.html',
  styleUrls: ['./user-alert-config.component.scss', './../components-conf.scss']
})
export class UserAlertConfigComponent implements OnInit {
  @Input() filterOptionsBy : string = ""

  constructor(
    public alertService : AlertService
  ) { }
  public configSections = configSections;
  public options = [
    { label: 'Vista Tabla', value: 'table' },
    { label: 'Vista Cards', value: 'cards' }
  ];

  public columnOptions = [
    { label: 'Numeración', value: 'index' },
    { label: 'Nombre', value: 'name' },
    { label: 'Cantidad de unidades', value: 'imeiCount' },
    { label: 'Alerta activo', value: 'isActive' },
    { label: 'Sonido activo', value: 'isActiveSoundSystem' },
    { label: 'Notificación por correo', value: 'isActiveNotificationEmail' },
    { label: 'Opciones', value: 'options' },
  ]
  public selectedColumns : any[] = [];



  public cardItemOptions = [
    { label: 'Nombre', value: 'name' },
    { label: 'Está activo', value: 'isActive' },
    { label: 'Tipo', value: 'type' },
    { label: 'Cantidad de unidades', value: 'imeiCount' },
    { label: 'Sonido activo', value: 'isActiveSoundSystem' },
    { label: 'Notificación por correo', value: 'isActiveNotificationEmail' },
    { label: 'Notificación por WhatsApp', value: 'isActiveNotificationWhatsapp' },
    { label: 'Opciones', value: 'options' },
  ];

  public selectedItems : any[] = [];



  ngOnInit(): void {
  this.selectedColumns = Object.keys(this.alertService.alertConfig.tableColumns)
    .filter(key => this.alertService.alertConfig.tableColumns[key]);

  this.selectedItems = Object.keys(this.alertService.alertConfig.cardItems)
    .filter(key => this.alertService.alertConfig.cardItems[key]);

  }

  public updateVisibleColumns() {
    Object.keys(this.alertService.alertConfig.tableColumns).forEach(key => {
      this.alertService.alertConfig.tableColumns[key] = false;
    });

    this.selectedColumns.forEach((column)=>{
      this.alertService.alertConfig.tableColumns[column] = true
    })
  }


  public updateVisibleCardItems() {
    Object.keys(this.alertService.alertConfig.cardItems).forEach(key => {
      this.alertService.alertConfig.cardItems[key] = false;
    });

    this.selectedItems.forEach((item)=>{
      this.alertService.alertConfig.cardItems[item] = true
    })
  }

  public toggleCreateAlert(event : boolean) {
    this.alertService.alertConfig.create.gps = event
    this.alertService.alertConfig.create.platform = event
    this.alertService.alertConfig.create.security = event
    this.alertService.alertConfig.create.mobile = event
    this.alertService.alertConfig.create.fatigue360 = event
  }
}
